import { Injectable, NgZone } from '@angular/core';
import { initialize, LDClient } from 'launchdarkly-js-client-sdk';
import { environment } from '../../environments/environment';

@Injectable()
export class LaunchDarklyService {
  ldClient:LDClient;
  currentUser: {
    id: string,
    firstName: string,
    lastName: string,
    role: string,
    hospitalId: number,
    transportationCompanyId: number
  };

  constructor(private zone: NgZone) {
    if(window.localStorage.getItem('currentUser')) {
      this.currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }

    if(this.currentUser) {
      this.ldClient = initialize(environment.launchDarklyClientApiKey,
        { kind: 'user', key: this.currentUser.id });
    } else {
      this.ldClient = initialize(environment.launchDarklyClientApiKey,
        { kind: 'user', key: 'anonymous', anonymous: true });
    }
  }

  subscribeFlag({flagName, user = null, callback, flagOptions = {}}:any={}): () => void {
    let flagParams = this.setFlagParams(flagName, user, flagOptions);

    // The LD client resolves/emits outside Angular's zone, so callbacks must
    // re-enter it or flag-driven view changes never trigger change detection.
    this.ldClient.waitForInitialization().then(() => {
      let flagValue = this.ldClient.variation(
        flagName,
        flagParams
      )
      this.zone.run(() => callback(flagValue));
    });

    const changeListener = (flagValue) => {
      this.zone.run(() => callback(flagValue));
    };
    this.ldClient.on(`change:${flagName}`, changeListener);

    return () => this.ldClient.off(`change:${flagName}`, changeListener);
  }

  setFlagParams(flagName, user, flagOptions) {
    let flagParams = {};

    if(!user) {
      flagParams['key'] = flagOptions['key'] || flagName
    } else {
      flagParams['key'] = user.id
    }

    if(flagOptions && flagOptions.hasOwnProperty('flagName')) {
      delete flagOptions.flagName
    }
    
    if(user) {
      flagParams['firstName'] = user.firstName;
      flagParams['lastName'] = user.lastName;
      flagParams['custom'] = {
        hospitalId: user.hospitalId,
        transportationCompanyId: user.transportationCompanyId,
        role: user.role
      }
    }

    if(flagOptions) {
      flagParams['custom'] = {
        ...flagParams['custom'],
        ...flagOptions
      }
    }

    return flagParams
  }
}
